<div class="container-modal-pucrchase-summary-details">
  @if ({
    request: request$ | async,
    }; as content) {
    @if (!content.request?.isLoading) {
      @if (!content.request?.hasError) {
        @if (content.request?.table?.length) {
          <table-pro [configs]="tableConfig">
            <table class="table-responsive table-md">
              <thead>
                <tr>
                  <th>{{ 'reports.purchaseSummaryDetails.table.header.partNumber' | cxTranslate }}</th>
                  <th>{{ 'reports.purchaseSummaryDetails.table.header.productDescription' | cxTranslate }}</th>
                  <th>{{ 'reports.purchaseSummaryDetails.table.header.quantity' | cxTranslate }}</th>
                  <th>{{ 'reports.purchaseSummaryDetails.table.header.sellingPrice' | cxTranslate }}</th>
                  <th>{{ 'reports.purchaseSummaryDetails.table.header.totalPrice' | cxTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (user of content.request?.table; track user) {
                  <tr>
                    <td [attr.data-value]="user.itemNumber">
                      <span class="responsive-title"> {{ 'reports.purchaseSummaryDetails.table.header.partNumber' | cxTranslate }}: </span>
                      {{ user.itemNumber }}
                    </td>
                    <td class="flex-col-description" [attr.data-value]="user.description">
                      <span class="responsive-title"> {{ 'reports.purchaseSummaryDetails.table.header.productDescription' | cxTranslate }}: </span>
                      {{ user.description }}
                    </td>
                    <td [attr.data-value]="user.quantity">
                      <span class="responsive-title"> {{ 'reports.purchaseSummaryDetails.table.header.quantity' | cxTranslate }}: </span>
                      {{ user.quantity }}
                    </td>
                    <td [attr.data-value]="user.sellingPrice?.value">
                      <span class="responsive-title"> {{ 'reports.purchaseSummaryDetails.table.header.sellingPrice' | cxTranslate }}: </span>
                      {{ user.sellingPrice?.formattedValue }}
                    </td>
                    <td [attr.data-value]="user.totalPrice?.value">
                      <span class="responsive-title"> {{ 'reports.purchaseSummaryDetails.table.header.totalPrice' | cxTranslate }}: </span>
                      {{ user.totalPrice?.formattedValue }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </table-pro>
        } @else {
          <p class="ff-bold text-center">{{ 'reports.noContent' | cxTranslate }}</p>
        }
      } @else {
        <alert [alert]="alertDanger"></alert>
      }
    } @else {
      <div class="m-t-20">
        <local-loader></local-loader>
      </div>
    }
  }
</div>